import { Filters } from './Filters';
import { Table } from './Table';

export const AdditionalPaymentsTable = () => {
  return (
    <>
      <Filters />
      <Table />
    </>
  );
};
